export const bankIdMessageCodeEnumTranslations = {
  RFA1: "Start your BankID app.",
  RFA2: "The BankID app is not installed. Please contact your bank.",
  RFA3: "Action cancelled. Please try again.",
  RFA4: "An identification or signing for this personal number is already started. Please try again.",
  RFA5: "Internal error. Please try again.",
  RFA6: "Action cancelled.",
  RFA8: "The BankID app is not responding. Please check that it’s started and that you have internet access. If you don’t have a valid BankID you can get one from your bank. Try again.",
  RFA9: "Enter your security code in the BankID app and select Identify or Sign.",
  RFA13: "Trying to start your BankID app.",
  RFA14:
    "Searching for BankID, it may take a little while …\n" +
    "If a few seconds have passed and still no BankID has been found, you probably don’t have a BankID which can be used for this identification/signing on this device. If you don’t have a BankID you can get one from your bank. If you have a BankID on another device you can start the BankID app on that device.",
  RFA15:
    "Searching for BankID, it may take a little while …\n" +
    "If a few seconds have passed and still no BankID has been found, you probably don’t have a BankID which can be used for this identification/signing on this device. If you don’t have a BankID you can get one from your bank.",
  RFA16:
    "The BankID you are trying to use is blocked or too old. Please use another BankID or get a new one from your bank.",
  RFA17:
    "The BankID app couldn’t be found on your computer or mobile device. Please install it and get a BankID from your bank.",
  RFA18: "Start the BankID app.",
  RFA19:
    "Would you like to identify yourself or sign with a BankID on this computer, or with a Mobile BankID?",
  RFA20:
    "Do you want to identify yourself or sign with a BankID on this device or with a BankID on another device?",
  RFA21: "Identification or signing in progress.",
  RFA22: "Unknown error. Please try again.",
  RFA23: "Process your machine-readable travel document using the BankID app.",
};
